import type { Backend } from '@freelancer/datastore/core';
import { OrderByDirection } from '@freelancer/datastore/core';
import type { EntryRestrictionsCollection } from './entry-restrictions.types';

export function entryRestrictionsBackend(): Backend<EntryRestrictionsCollection> {
  return {
    defaultOrder: [
      {
        field: 'id',
        direction: OrderByDirection.ASC,
      },
    ],
    maxBatchSize: 1, // This endpoint only supports querying one document at a time.

    fetch: (authUid, ids = [], query) => {
      if (ids.length !== 1) {
        throw new Error(
          'Entry Restrictions only supports single document queries',
        );
      }

      // Parse the ID - expecting format: userId_contestId
      const idParts = ids[0].toString().split('_');
      if (idParts.length !== 2) {
        throw new Error(
          'Entry Restrictions requires ID in format: userId_contestId',
        );
      }

      // Extract the contestId from the concatenated ID
      const contestId = parseInt(idParts[1], 10);

      return {
        endpoint: 'contests/getContestEntryRequirements.php',
        isGaf: true,
        params: {
          contestId,
        },
      };
    },
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
